import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-3 items-center" }

import RezTabFile from '@/store/modules/RezTabFile';
import { ref } from 'vue';
import { useStore } from 'vuex';
import ProportionSelector from './ProportionSelector.vue';
import { useDoc } from '@/composables/useDoc';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const someBoolean = ref(false)
const store = useStore();

return (_ctx: any,_cache: any) => {
  const _component_va_button = _resolveComponent("va-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", _hoisted_1, [
        _createVNode(_component_va_button, {
          color: "onPrimary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).state.currentDoc as RezTabFile).turnOnDefaultFirstTabgroupDurSymShow()))
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode(" set first durSyms", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_va_button, {
          color: "onPrimary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ((_unref(store).state.currentDoc as RezTabFile).turnOnDefaultFirstTabgroupDurSymShow({ resetEachMeasure: true })))
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode(" set first durSyms (reset each measure)", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_va_button, {
          color: "onPrimary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(useDoc)().toggleTabgroupsIncludeDurAttribute()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString((_unref(useDoc)().docSettings.tabgroupsIncludeDurAttribute ? 'remove' : 'add') + ' Tab groups "dur" ' +
                        'attribute'), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(ProportionSelector)
      ])
    ])
  ]))
}
}

})